module.exports = __webpack_public_path__ + "dax-regular.458d12e409b10919c69b.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/assets/fonts/dax/dax-regular.woff2
// module id = ../../../../../src/assets/fonts/dax/dax-regular.woff2
// module chunks = styles